import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Footer.css';
import logo from '../assets/images/logo.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Afaan Oromo Logo" />
            <p>Your gateway to Oromo language and culture</p>
          </div>
          
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/service">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p><i className="fas fa-map-marker-alt"></i> 123 Learning Street, Sheffield, S1 2AB, UK</p>
            <p><i className="fas fa-phone"></i> +44 7883394617</p>
            <p><i className="fas fa-envelope"></i> info@afaanoromo.com</p>
          </div>
          
          <div className="footer-social">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="https://facebook.com/abdullah.siraj.sheffield" target="_blank" rel="noopener noreferrer" aria-label="Abdullah Siraj from Sheffield">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/Abdullah.Siraj.Sheffield" target="_blank" rel="noopener noreferrer" aria-label="Abdullah Siraj (Sheffield)">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://instagram.com/abdullah.siraj.sheffield" target="_blank" rel="noopener noreferrer" aria-label="Abdullah Siraj from Sheffield">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://linkedin.com/in/abdullah-siraj-sheffield" target="_blank" rel="noopener noreferrer" aria-label="Abdullah Siraj from Sheffield">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" aria-label="TEACH OROMOO LANGUAGE BY DR.ABDULLAH SIRAJ">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Afaan Oromo. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/cookie-policy">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;